// extracted by css-extract-rspack-plugin
export default {"banner":"UiBanner_banner_VDF8L"};